<section class="no-access" fxLayout="column" fxLayoutAlign="center">
  <img src="assets/images/error-placeholder.svg" width="200" height="200" class="centered mb-7" [alt]="'deviceSetup.noAccess.title' | translate">
  <h1 class="text-bold text-danger">{{'deviceSetup.noAccess.title' | translate}}</h1>
  <p [innerHtml]="'deviceSetup.noAccess.content' | translate" class="text-hint"></p>
  <button mat-raised-button (click)="logOut()">{{ 'client.log-out' | translate }}</button>
</section>
